/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as ResetPasswordRouteImport } from "./routes/reset-password";
import { Route as NotFoundRouteImport } from "./routes/not-found";
import { Route as MobileRequiredRouteImport } from "./routes/mobile-required";
import { Route as CoachMatchingRouteImport } from "./routes/coach-matching";
import { Route as SessionCodeRouteImport } from "./routes/$sessionCode";
import { Route as DevRouteRouteImport } from "./routes/dev/route";
import { Route as IndexRouteImport } from "./routes/index";
import { Route as SupportIndexRouteImport } from "./routes/support/index";
import { Route as DevIndexRouteImport } from "./routes/dev/index";
import { Route as SessionCodeIndexRouteImport } from "./routes/$sessionCode/index";
import { Route as SurveyIdRouteImport } from "./routes/survey/$id";
import { Route as SupportConfirmationRouteImport } from "./routes/support/confirmation";
import { Route as EmbedConciergeBookingRouteImport } from "./routes/embed/concierge-booking";
import { Route as EmbedCoachMatchingRouteImport } from "./routes/embed/coach-matching";
import { Route as DevSurveyLoadingRouteImport } from "./routes/dev/survey-loading";
import { Route as DevSurveyFlowRouteImport } from "./routes/dev/survey-flow";
import { Route as DevSurveyComponentsRouteImport } from "./routes/dev/survey-components";
import { Route as DevJoinLoadingRouteImport } from "./routes/dev/join-loading";
import { Route as DevBookingTimezoneRouteImport } from "./routes/dev/booking-timezone";
import { Route as DevBookingNotesRouteImport } from "./routes/dev/booking-notes";
import { Route as DevBookingEndStatesRouteImport } from "./routes/dev/booking-end-states";
import { Route as DevAvailabilityFailureRouteImport } from "./routes/dev/availability-failure";
import { Route as EmbedSupportIndexRouteImport } from "./routes/embed/support/index";
import { Route as EmbedBookIndexRouteImport } from "./routes/embed/book/index";
import { Route as SessionCodeBookIndexRouteImport } from "./routes/$sessionCode/book/index";
import { Route as EmbedSupportConfirmationRouteImport } from "./routes/embed/support/confirmation";
import { Route as EmbedBookSuccessRouteImport } from "./routes/embed/book/success";
import { Route as SessionCodeRescheduleRescheduleUuidRouteImport } from "./routes/$sessionCode/reschedule/$rescheduleUuid";
import { Route as SessionCodeCancelCancelUuidIndexRouteImport } from "./routes/$sessionCode/cancel/$cancelUuid/index";
import { Route as CoachSlugCoachingSessionBookingCodeIndexRouteImport } from "./routes/$coachSlug/coaching-session/$bookingCode/index";
import { Route as SessionCodeCancelCancelUuidSuccessRouteImport } from "./routes/$sessionCode/cancel/$cancelUuid/success";

const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: "/reset-password",
  path: "/reset-password",
  getParentRoute: () => rootRouteImport,
} as any);
const NotFoundRoute = NotFoundRouteImport.update({
  id: "/not-found",
  path: "/not-found",
  getParentRoute: () => rootRouteImport,
} as any);
const MobileRequiredRoute = MobileRequiredRouteImport.update({
  id: "/mobile-required",
  path: "/mobile-required",
  getParentRoute: () => rootRouteImport,
} as any);
const CoachMatchingRoute = CoachMatchingRouteImport.update({
  id: "/coach-matching",
  path: "/coach-matching",
  getParentRoute: () => rootRouteImport,
} as any);
const SessionCodeRoute = SessionCodeRouteImport.update({
  id: "/$sessionCode",
  path: "/$sessionCode",
  getParentRoute: () => rootRouteImport,
} as any);
const DevRouteRoute = DevRouteRouteImport.update({
  id: "/dev",
  path: "/dev",
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);
const SupportIndexRoute = SupportIndexRouteImport.update({
  id: "/support/",
  path: "/support/",
  getParentRoute: () => rootRouteImport,
} as any);
const DevIndexRoute = DevIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => DevRouteRoute,
} as any);
const SessionCodeIndexRoute = SessionCodeIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => SessionCodeRoute,
} as any);
const SurveyIdRoute = SurveyIdRouteImport.update({
  id: "/survey/$id",
  path: "/survey/$id",
  getParentRoute: () => rootRouteImport,
} as any);
const SupportConfirmationRoute = SupportConfirmationRouteImport.update({
  id: "/support/confirmation",
  path: "/support/confirmation",
  getParentRoute: () => rootRouteImport,
} as any);
const EmbedConciergeBookingRoute = EmbedConciergeBookingRouteImport.update({
  id: "/embed/concierge-booking",
  path: "/embed/concierge-booking",
  getParentRoute: () => rootRouteImport,
} as any);
const EmbedCoachMatchingRoute = EmbedCoachMatchingRouteImport.update({
  id: "/embed/coach-matching",
  path: "/embed/coach-matching",
  getParentRoute: () => rootRouteImport,
} as any);
const DevSurveyLoadingRoute = DevSurveyLoadingRouteImport.update({
  id: "/survey-loading",
  path: "/survey-loading",
  getParentRoute: () => DevRouteRoute,
} as any);
const DevSurveyFlowRoute = DevSurveyFlowRouteImport.update({
  id: "/survey-flow",
  path: "/survey-flow",
  getParentRoute: () => DevRouteRoute,
} as any);
const DevSurveyComponentsRoute = DevSurveyComponentsRouteImport.update({
  id: "/survey-components",
  path: "/survey-components",
  getParentRoute: () => DevRouteRoute,
} as any);
const DevJoinLoadingRoute = DevJoinLoadingRouteImport.update({
  id: "/join-loading",
  path: "/join-loading",
  getParentRoute: () => DevRouteRoute,
} as any);
const DevBookingTimezoneRoute = DevBookingTimezoneRouteImport.update({
  id: "/booking-timezone",
  path: "/booking-timezone",
  getParentRoute: () => DevRouteRoute,
} as any);
const DevBookingNotesRoute = DevBookingNotesRouteImport.update({
  id: "/booking-notes",
  path: "/booking-notes",
  getParentRoute: () => DevRouteRoute,
} as any);
const DevBookingEndStatesRoute = DevBookingEndStatesRouteImport.update({
  id: "/booking-end-states",
  path: "/booking-end-states",
  getParentRoute: () => DevRouteRoute,
} as any);
const DevAvailabilityFailureRoute = DevAvailabilityFailureRouteImport.update({
  id: "/availability-failure",
  path: "/availability-failure",
  getParentRoute: () => DevRouteRoute,
} as any);
const EmbedSupportIndexRoute = EmbedSupportIndexRouteImport.update({
  id: "/embed/support/",
  path: "/embed/support/",
  getParentRoute: () => rootRouteImport,
} as any);
const EmbedBookIndexRoute = EmbedBookIndexRouteImport.update({
  id: "/embed/book/",
  path: "/embed/book/",
  getParentRoute: () => rootRouteImport,
} as any);
const SessionCodeBookIndexRoute = SessionCodeBookIndexRouteImport.update({
  id: "/book/",
  path: "/book/",
  getParentRoute: () => SessionCodeRoute,
} as any);
const EmbedSupportConfirmationRoute =
  EmbedSupportConfirmationRouteImport.update({
    id: "/embed/support/confirmation",
    path: "/embed/support/confirmation",
    getParentRoute: () => rootRouteImport,
  } as any);
const EmbedBookSuccessRoute = EmbedBookSuccessRouteImport.update({
  id: "/embed/book/success",
  path: "/embed/book/success",
  getParentRoute: () => rootRouteImport,
} as any);
const SessionCodeRescheduleRescheduleUuidRoute =
  SessionCodeRescheduleRescheduleUuidRouteImport.update({
    id: "/reschedule/$rescheduleUuid",
    path: "/reschedule/$rescheduleUuid",
    getParentRoute: () => SessionCodeRoute,
  } as any);
const SessionCodeCancelCancelUuidIndexRoute =
  SessionCodeCancelCancelUuidIndexRouteImport.update({
    id: "/cancel/$cancelUuid/",
    path: "/cancel/$cancelUuid/",
    getParentRoute: () => SessionCodeRoute,
  } as any);
const CoachSlugCoachingSessionBookingCodeIndexRoute =
  CoachSlugCoachingSessionBookingCodeIndexRouteImport.update({
    id: "/$coachSlug/coaching-session/$bookingCode/",
    path: "/$coachSlug/coaching-session/$bookingCode/",
    getParentRoute: () => rootRouteImport,
  } as any);
const SessionCodeCancelCancelUuidSuccessRoute =
  SessionCodeCancelCancelUuidSuccessRouteImport.update({
    id: "/cancel/$cancelUuid/success",
    path: "/cancel/$cancelUuid/success",
    getParentRoute: () => SessionCodeRoute,
  } as any);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/dev": typeof DevRouteRouteWithChildren;
  "/$sessionCode": typeof SessionCodeRouteWithChildren;
  "/coach-matching": typeof CoachMatchingRoute;
  "/mobile-required": typeof MobileRequiredRoute;
  "/not-found": typeof NotFoundRoute;
  "/reset-password": typeof ResetPasswordRoute;
  "/dev/availability-failure": typeof DevAvailabilityFailureRoute;
  "/dev/booking-end-states": typeof DevBookingEndStatesRoute;
  "/dev/booking-notes": typeof DevBookingNotesRoute;
  "/dev/booking-timezone": typeof DevBookingTimezoneRoute;
  "/dev/join-loading": typeof DevJoinLoadingRoute;
  "/dev/survey-components": typeof DevSurveyComponentsRoute;
  "/dev/survey-flow": typeof DevSurveyFlowRoute;
  "/dev/survey-loading": typeof DevSurveyLoadingRoute;
  "/embed/coach-matching": typeof EmbedCoachMatchingRoute;
  "/embed/concierge-booking": typeof EmbedConciergeBookingRoute;
  "/support/confirmation": typeof SupportConfirmationRoute;
  "/survey/$id": typeof SurveyIdRoute;
  "/$sessionCode/": typeof SessionCodeIndexRoute;
  "/dev/": typeof DevIndexRoute;
  "/support": typeof SupportIndexRoute;
  "/$sessionCode/reschedule/$rescheduleUuid": typeof SessionCodeRescheduleRescheduleUuidRoute;
  "/embed/book/success": typeof EmbedBookSuccessRoute;
  "/embed/support/confirmation": typeof EmbedSupportConfirmationRoute;
  "/$sessionCode/book": typeof SessionCodeBookIndexRoute;
  "/embed/book": typeof EmbedBookIndexRoute;
  "/embed/support": typeof EmbedSupportIndexRoute;
  "/$sessionCode/cancel/$cancelUuid/success": typeof SessionCodeCancelCancelUuidSuccessRoute;
  "/$coachSlug/coaching-session/$bookingCode": typeof CoachSlugCoachingSessionBookingCodeIndexRoute;
  "/$sessionCode/cancel/$cancelUuid": typeof SessionCodeCancelCancelUuidIndexRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/coach-matching": typeof CoachMatchingRoute;
  "/mobile-required": typeof MobileRequiredRoute;
  "/not-found": typeof NotFoundRoute;
  "/reset-password": typeof ResetPasswordRoute;
  "/dev/availability-failure": typeof DevAvailabilityFailureRoute;
  "/dev/booking-end-states": typeof DevBookingEndStatesRoute;
  "/dev/booking-notes": typeof DevBookingNotesRoute;
  "/dev/booking-timezone": typeof DevBookingTimezoneRoute;
  "/dev/join-loading": typeof DevJoinLoadingRoute;
  "/dev/survey-components": typeof DevSurveyComponentsRoute;
  "/dev/survey-flow": typeof DevSurveyFlowRoute;
  "/dev/survey-loading": typeof DevSurveyLoadingRoute;
  "/embed/coach-matching": typeof EmbedCoachMatchingRoute;
  "/embed/concierge-booking": typeof EmbedConciergeBookingRoute;
  "/support/confirmation": typeof SupportConfirmationRoute;
  "/survey/$id": typeof SurveyIdRoute;
  "/$sessionCode": typeof SessionCodeIndexRoute;
  "/dev": typeof DevIndexRoute;
  "/support": typeof SupportIndexRoute;
  "/$sessionCode/reschedule/$rescheduleUuid": typeof SessionCodeRescheduleRescheduleUuidRoute;
  "/embed/book/success": typeof EmbedBookSuccessRoute;
  "/embed/support/confirmation": typeof EmbedSupportConfirmationRoute;
  "/$sessionCode/book": typeof SessionCodeBookIndexRoute;
  "/embed/book": typeof EmbedBookIndexRoute;
  "/embed/support": typeof EmbedSupportIndexRoute;
  "/$sessionCode/cancel/$cancelUuid/success": typeof SessionCodeCancelCancelUuidSuccessRoute;
  "/$coachSlug/coaching-session/$bookingCode": typeof CoachSlugCoachingSessionBookingCodeIndexRoute;
  "/$sessionCode/cancel/$cancelUuid": typeof SessionCodeCancelCancelUuidIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/dev": typeof DevRouteRouteWithChildren;
  "/$sessionCode": typeof SessionCodeRouteWithChildren;
  "/coach-matching": typeof CoachMatchingRoute;
  "/mobile-required": typeof MobileRequiredRoute;
  "/not-found": typeof NotFoundRoute;
  "/reset-password": typeof ResetPasswordRoute;
  "/dev/availability-failure": typeof DevAvailabilityFailureRoute;
  "/dev/booking-end-states": typeof DevBookingEndStatesRoute;
  "/dev/booking-notes": typeof DevBookingNotesRoute;
  "/dev/booking-timezone": typeof DevBookingTimezoneRoute;
  "/dev/join-loading": typeof DevJoinLoadingRoute;
  "/dev/survey-components": typeof DevSurveyComponentsRoute;
  "/dev/survey-flow": typeof DevSurveyFlowRoute;
  "/dev/survey-loading": typeof DevSurveyLoadingRoute;
  "/embed/coach-matching": typeof EmbedCoachMatchingRoute;
  "/embed/concierge-booking": typeof EmbedConciergeBookingRoute;
  "/support/confirmation": typeof SupportConfirmationRoute;
  "/survey/$id": typeof SurveyIdRoute;
  "/$sessionCode/": typeof SessionCodeIndexRoute;
  "/dev/": typeof DevIndexRoute;
  "/support/": typeof SupportIndexRoute;
  "/$sessionCode/reschedule/$rescheduleUuid": typeof SessionCodeRescheduleRescheduleUuidRoute;
  "/embed/book/success": typeof EmbedBookSuccessRoute;
  "/embed/support/confirmation": typeof EmbedSupportConfirmationRoute;
  "/$sessionCode/book/": typeof SessionCodeBookIndexRoute;
  "/embed/book/": typeof EmbedBookIndexRoute;
  "/embed/support/": typeof EmbedSupportIndexRoute;
  "/$sessionCode/cancel/$cancelUuid/success": typeof SessionCodeCancelCancelUuidSuccessRoute;
  "/$coachSlug/coaching-session/$bookingCode/": typeof CoachSlugCoachingSessionBookingCodeIndexRoute;
  "/$sessionCode/cancel/$cancelUuid/": typeof SessionCodeCancelCancelUuidIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/dev"
    | "/$sessionCode"
    | "/coach-matching"
    | "/mobile-required"
    | "/not-found"
    | "/reset-password"
    | "/dev/availability-failure"
    | "/dev/booking-end-states"
    | "/dev/booking-notes"
    | "/dev/booking-timezone"
    | "/dev/join-loading"
    | "/dev/survey-components"
    | "/dev/survey-flow"
    | "/dev/survey-loading"
    | "/embed/coach-matching"
    | "/embed/concierge-booking"
    | "/support/confirmation"
    | "/survey/$id"
    | "/$sessionCode/"
    | "/dev/"
    | "/support"
    | "/$sessionCode/reschedule/$rescheduleUuid"
    | "/embed/book/success"
    | "/embed/support/confirmation"
    | "/$sessionCode/book"
    | "/embed/book"
    | "/embed/support"
    | "/$sessionCode/cancel/$cancelUuid/success"
    | "/$coachSlug/coaching-session/$bookingCode"
    | "/$sessionCode/cancel/$cancelUuid";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/coach-matching"
    | "/mobile-required"
    | "/not-found"
    | "/reset-password"
    | "/dev/availability-failure"
    | "/dev/booking-end-states"
    | "/dev/booking-notes"
    | "/dev/booking-timezone"
    | "/dev/join-loading"
    | "/dev/survey-components"
    | "/dev/survey-flow"
    | "/dev/survey-loading"
    | "/embed/coach-matching"
    | "/embed/concierge-booking"
    | "/support/confirmation"
    | "/survey/$id"
    | "/$sessionCode"
    | "/dev"
    | "/support"
    | "/$sessionCode/reschedule/$rescheduleUuid"
    | "/embed/book/success"
    | "/embed/support/confirmation"
    | "/$sessionCode/book"
    | "/embed/book"
    | "/embed/support"
    | "/$sessionCode/cancel/$cancelUuid/success"
    | "/$coachSlug/coaching-session/$bookingCode"
    | "/$sessionCode/cancel/$cancelUuid";
  id:
    | "__root__"
    | "/"
    | "/dev"
    | "/$sessionCode"
    | "/coach-matching"
    | "/mobile-required"
    | "/not-found"
    | "/reset-password"
    | "/dev/availability-failure"
    | "/dev/booking-end-states"
    | "/dev/booking-notes"
    | "/dev/booking-timezone"
    | "/dev/join-loading"
    | "/dev/survey-components"
    | "/dev/survey-flow"
    | "/dev/survey-loading"
    | "/embed/coach-matching"
    | "/embed/concierge-booking"
    | "/support/confirmation"
    | "/survey/$id"
    | "/$sessionCode/"
    | "/dev/"
    | "/support/"
    | "/$sessionCode/reschedule/$rescheduleUuid"
    | "/embed/book/success"
    | "/embed/support/confirmation"
    | "/$sessionCode/book/"
    | "/embed/book/"
    | "/embed/support/"
    | "/$sessionCode/cancel/$cancelUuid/success"
    | "/$coachSlug/coaching-session/$bookingCode/"
    | "/$sessionCode/cancel/$cancelUuid/";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  DevRouteRoute: typeof DevRouteRouteWithChildren;
  SessionCodeRoute: typeof SessionCodeRouteWithChildren;
  CoachMatchingRoute: typeof CoachMatchingRoute;
  MobileRequiredRoute: typeof MobileRequiredRoute;
  NotFoundRoute: typeof NotFoundRoute;
  ResetPasswordRoute: typeof ResetPasswordRoute;
  EmbedCoachMatchingRoute: typeof EmbedCoachMatchingRoute;
  EmbedConciergeBookingRoute: typeof EmbedConciergeBookingRoute;
  SupportConfirmationRoute: typeof SupportConfirmationRoute;
  SurveyIdRoute: typeof SurveyIdRoute;
  SupportIndexRoute: typeof SupportIndexRoute;
  EmbedBookSuccessRoute: typeof EmbedBookSuccessRoute;
  EmbedSupportConfirmationRoute: typeof EmbedSupportConfirmationRoute;
  EmbedBookIndexRoute: typeof EmbedBookIndexRoute;
  EmbedSupportIndexRoute: typeof EmbedSupportIndexRoute;
  CoachSlugCoachingSessionBookingCodeIndexRoute: typeof CoachSlugCoachingSessionBookingCodeIndexRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/reset-password": {
      id: "/reset-password";
      path: "/reset-password";
      fullPath: "/reset-password";
      preLoaderRoute: typeof ResetPasswordRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/not-found": {
      id: "/not-found";
      path: "/not-found";
      fullPath: "/not-found";
      preLoaderRoute: typeof NotFoundRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/mobile-required": {
      id: "/mobile-required";
      path: "/mobile-required";
      fullPath: "/mobile-required";
      preLoaderRoute: typeof MobileRequiredRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/coach-matching": {
      id: "/coach-matching";
      path: "/coach-matching";
      fullPath: "/coach-matching";
      preLoaderRoute: typeof CoachMatchingRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/$sessionCode": {
      id: "/$sessionCode";
      path: "/$sessionCode";
      fullPath: "/$sessionCode";
      preLoaderRoute: typeof SessionCodeRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/dev": {
      id: "/dev";
      path: "/dev";
      fullPath: "/dev";
      preLoaderRoute: typeof DevRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/support/": {
      id: "/support/";
      path: "/support";
      fullPath: "/support";
      preLoaderRoute: typeof SupportIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/dev/": {
      id: "/dev/";
      path: "/";
      fullPath: "/dev/";
      preLoaderRoute: typeof DevIndexRouteImport;
      parentRoute: typeof DevRouteRoute;
    };
    "/$sessionCode/": {
      id: "/$sessionCode/";
      path: "/";
      fullPath: "/$sessionCode/";
      preLoaderRoute: typeof SessionCodeIndexRouteImport;
      parentRoute: typeof SessionCodeRoute;
    };
    "/survey/$id": {
      id: "/survey/$id";
      path: "/survey/$id";
      fullPath: "/survey/$id";
      preLoaderRoute: typeof SurveyIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/support/confirmation": {
      id: "/support/confirmation";
      path: "/support/confirmation";
      fullPath: "/support/confirmation";
      preLoaderRoute: typeof SupportConfirmationRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/embed/concierge-booking": {
      id: "/embed/concierge-booking";
      path: "/embed/concierge-booking";
      fullPath: "/embed/concierge-booking";
      preLoaderRoute: typeof EmbedConciergeBookingRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/embed/coach-matching": {
      id: "/embed/coach-matching";
      path: "/embed/coach-matching";
      fullPath: "/embed/coach-matching";
      preLoaderRoute: typeof EmbedCoachMatchingRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/dev/survey-loading": {
      id: "/dev/survey-loading";
      path: "/survey-loading";
      fullPath: "/dev/survey-loading";
      preLoaderRoute: typeof DevSurveyLoadingRouteImport;
      parentRoute: typeof DevRouteRoute;
    };
    "/dev/survey-flow": {
      id: "/dev/survey-flow";
      path: "/survey-flow";
      fullPath: "/dev/survey-flow";
      preLoaderRoute: typeof DevSurveyFlowRouteImport;
      parentRoute: typeof DevRouteRoute;
    };
    "/dev/survey-components": {
      id: "/dev/survey-components";
      path: "/survey-components";
      fullPath: "/dev/survey-components";
      preLoaderRoute: typeof DevSurveyComponentsRouteImport;
      parentRoute: typeof DevRouteRoute;
    };
    "/dev/join-loading": {
      id: "/dev/join-loading";
      path: "/join-loading";
      fullPath: "/dev/join-loading";
      preLoaderRoute: typeof DevJoinLoadingRouteImport;
      parentRoute: typeof DevRouteRoute;
    };
    "/dev/booking-timezone": {
      id: "/dev/booking-timezone";
      path: "/booking-timezone";
      fullPath: "/dev/booking-timezone";
      preLoaderRoute: typeof DevBookingTimezoneRouteImport;
      parentRoute: typeof DevRouteRoute;
    };
    "/dev/booking-notes": {
      id: "/dev/booking-notes";
      path: "/booking-notes";
      fullPath: "/dev/booking-notes";
      preLoaderRoute: typeof DevBookingNotesRouteImport;
      parentRoute: typeof DevRouteRoute;
    };
    "/dev/booking-end-states": {
      id: "/dev/booking-end-states";
      path: "/booking-end-states";
      fullPath: "/dev/booking-end-states";
      preLoaderRoute: typeof DevBookingEndStatesRouteImport;
      parentRoute: typeof DevRouteRoute;
    };
    "/dev/availability-failure": {
      id: "/dev/availability-failure";
      path: "/availability-failure";
      fullPath: "/dev/availability-failure";
      preLoaderRoute: typeof DevAvailabilityFailureRouteImport;
      parentRoute: typeof DevRouteRoute;
    };
    "/embed/support/": {
      id: "/embed/support/";
      path: "/embed/support";
      fullPath: "/embed/support";
      preLoaderRoute: typeof EmbedSupportIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/embed/book/": {
      id: "/embed/book/";
      path: "/embed/book";
      fullPath: "/embed/book";
      preLoaderRoute: typeof EmbedBookIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/$sessionCode/book/": {
      id: "/$sessionCode/book/";
      path: "/book";
      fullPath: "/$sessionCode/book";
      preLoaderRoute: typeof SessionCodeBookIndexRouteImport;
      parentRoute: typeof SessionCodeRoute;
    };
    "/embed/support/confirmation": {
      id: "/embed/support/confirmation";
      path: "/embed/support/confirmation";
      fullPath: "/embed/support/confirmation";
      preLoaderRoute: typeof EmbedSupportConfirmationRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/embed/book/success": {
      id: "/embed/book/success";
      path: "/embed/book/success";
      fullPath: "/embed/book/success";
      preLoaderRoute: typeof EmbedBookSuccessRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/$sessionCode/reschedule/$rescheduleUuid": {
      id: "/$sessionCode/reschedule/$rescheduleUuid";
      path: "/reschedule/$rescheduleUuid";
      fullPath: "/$sessionCode/reschedule/$rescheduleUuid";
      preLoaderRoute: typeof SessionCodeRescheduleRescheduleUuidRouteImport;
      parentRoute: typeof SessionCodeRoute;
    };
    "/$sessionCode/cancel/$cancelUuid/": {
      id: "/$sessionCode/cancel/$cancelUuid/";
      path: "/cancel/$cancelUuid";
      fullPath: "/$sessionCode/cancel/$cancelUuid";
      preLoaderRoute: typeof SessionCodeCancelCancelUuidIndexRouteImport;
      parentRoute: typeof SessionCodeRoute;
    };
    "/$coachSlug/coaching-session/$bookingCode/": {
      id: "/$coachSlug/coaching-session/$bookingCode/";
      path: "/$coachSlug/coaching-session/$bookingCode";
      fullPath: "/$coachSlug/coaching-session/$bookingCode";
      preLoaderRoute: typeof CoachSlugCoachingSessionBookingCodeIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/$sessionCode/cancel/$cancelUuid/success": {
      id: "/$sessionCode/cancel/$cancelUuid/success";
      path: "/cancel/$cancelUuid/success";
      fullPath: "/$sessionCode/cancel/$cancelUuid/success";
      preLoaderRoute: typeof SessionCodeCancelCancelUuidSuccessRouteImport;
      parentRoute: typeof SessionCodeRoute;
    };
  }
}

interface DevRouteRouteChildren {
  DevAvailabilityFailureRoute: typeof DevAvailabilityFailureRoute;
  DevBookingEndStatesRoute: typeof DevBookingEndStatesRoute;
  DevBookingNotesRoute: typeof DevBookingNotesRoute;
  DevBookingTimezoneRoute: typeof DevBookingTimezoneRoute;
  DevJoinLoadingRoute: typeof DevJoinLoadingRoute;
  DevSurveyComponentsRoute: typeof DevSurveyComponentsRoute;
  DevSurveyFlowRoute: typeof DevSurveyFlowRoute;
  DevSurveyLoadingRoute: typeof DevSurveyLoadingRoute;
  DevIndexRoute: typeof DevIndexRoute;
}

const DevRouteRouteChildren: DevRouteRouteChildren = {
  DevAvailabilityFailureRoute: DevAvailabilityFailureRoute,
  DevBookingEndStatesRoute: DevBookingEndStatesRoute,
  DevBookingNotesRoute: DevBookingNotesRoute,
  DevBookingTimezoneRoute: DevBookingTimezoneRoute,
  DevJoinLoadingRoute: DevJoinLoadingRoute,
  DevSurveyComponentsRoute: DevSurveyComponentsRoute,
  DevSurveyFlowRoute: DevSurveyFlowRoute,
  DevSurveyLoadingRoute: DevSurveyLoadingRoute,
  DevIndexRoute: DevIndexRoute,
};

const DevRouteRouteWithChildren = DevRouteRoute._addFileChildren(
  DevRouteRouteChildren,
);

interface SessionCodeRouteChildren {
  SessionCodeIndexRoute: typeof SessionCodeIndexRoute;
  SessionCodeRescheduleRescheduleUuidRoute: typeof SessionCodeRescheduleRescheduleUuidRoute;
  SessionCodeBookIndexRoute: typeof SessionCodeBookIndexRoute;
  SessionCodeCancelCancelUuidSuccessRoute: typeof SessionCodeCancelCancelUuidSuccessRoute;
  SessionCodeCancelCancelUuidIndexRoute: typeof SessionCodeCancelCancelUuidIndexRoute;
}

const SessionCodeRouteChildren: SessionCodeRouteChildren = {
  SessionCodeIndexRoute: SessionCodeIndexRoute,
  SessionCodeRescheduleRescheduleUuidRoute:
    SessionCodeRescheduleRescheduleUuidRoute,
  SessionCodeBookIndexRoute: SessionCodeBookIndexRoute,
  SessionCodeCancelCancelUuidSuccessRoute:
    SessionCodeCancelCancelUuidSuccessRoute,
  SessionCodeCancelCancelUuidIndexRoute: SessionCodeCancelCancelUuidIndexRoute,
};

const SessionCodeRouteWithChildren = SessionCodeRoute._addFileChildren(
  SessionCodeRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DevRouteRoute: DevRouteRouteWithChildren,
  SessionCodeRoute: SessionCodeRouteWithChildren,
  CoachMatchingRoute: CoachMatchingRoute,
  MobileRequiredRoute: MobileRequiredRoute,
  NotFoundRoute: NotFoundRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  EmbedCoachMatchingRoute: EmbedCoachMatchingRoute,
  EmbedConciergeBookingRoute: EmbedConciergeBookingRoute,
  SupportConfirmationRoute: SupportConfirmationRoute,
  SurveyIdRoute: SurveyIdRoute,
  SupportIndexRoute: SupportIndexRoute,
  EmbedBookSuccessRoute: EmbedBookSuccessRoute,
  EmbedSupportConfirmationRoute: EmbedSupportConfirmationRoute,
  EmbedBookIndexRoute: EmbedBookIndexRoute,
  EmbedSupportIndexRoute: EmbedSupportIndexRoute,
  CoachSlugCoachingSessionBookingCodeIndexRoute:
    CoachSlugCoachingSessionBookingCodeIndexRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
